module.exports = __webpack_public_path__ + "static/media/4.bb56fdd3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/4.png
 ** module id = 419
 ** module chunks = 0
 **/